import React, {Component} from 'react';
import {Table} from 'react-bootstrap';
import classnames from 'classnames';
import {dateFormatUK} from '../../../../utils/commonFunctions';

const DataRow = ({label, children}) => (
  <tr>
    <td>{label}</td>
    <td>{children}</td>
  </tr>
);

class AppSettingsTable extends Component {
  render() {
    const {loading, apiKey} = this.props;


    return (
      <Table hover responsive>
        <tbody className="text-center">
          <tr className={classnames({hidden: !loading})}>
            <td colSpan={2}>Loading data...</td>
          </tr>
          <DataRow label="Current key:">{apiKey.key}</DataRow>
          <DataRow label="Generated on:">{dateFormatUK(apiKey.created_at)}</DataRow>
          <DataRow label="API accessed on:">{dateFormatUK(apiKey.accessed_at)}</DataRow>
        </tbody>
      </Table>
    );
  }
}

export default AppSettingsTable;



// WEBPACK FOOTER //
// ./src/components/admin/app/app-settings/app-settings-table.jsx